<template>
  <el-dialog
    :model-value="dialogVisible"
    :title="dialogTitle"
    width="50%"
    @close="handleClose"
  >
    <el-form ref="formRef" :model="form" label-width="100px" :rules="rules">

      <el-form-item label="产品名称" prop="proName">
        <el-input v-model="form.proName" style="width: 400px"></el-input>
      </el-form-item>

      <el-form-item label="产品价格" prop="price">
        <el-input v-model="form.proPrice" style="width: 100px"></el-input>
      </el-form-item>

      <el-form-item label="产品库存" prop="stock">
        <el-input v-model="form.proStock" style="width: 100px"></el-input>
      </el-form-item>

      <el-form-item label="产品排序">
        <el-input-number v-model="form.proSort" :min="0" controls-position="right" style="width: 160px"></el-input-number>
        <span class="sort-tip">数值越小越靠前</span>
      </el-form-item>

      <el-form-item label="产品类别" >
        <el-select v-model="bigTypeId"  class="m-2" placeholder="请选择产品大类..." @change="handleBigTypeChange">
          <el-option
            v-for="item in bigTypeSlectOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        &nbsp;&nbsp;
        <el-select v-model="smallTypeId" class="m-2" placeholder="请选择产品小类..." >
          <el-option
            v-for="item in smallTypeSlectOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="产品描述" prop="description">
        <el-input
          v-model="form.description"
          :rows="4"
          type="textarea"
        />
      </el-form-item>

      <el-form-item  label="产品相关介绍" v-if="hasValidId" ></el-form-item>
      <QuillEditor
        v-if="hasValidId"
        v-model:content="quillIntroImgs"
        :key="quillKey"
        contentType="html"
        toolbar="full"
        theme="snow"
        style="height:200px"
        @ready="handleEditorReady"
      />


    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleConfirm"
        >确认</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { defineEmits,ref ,defineProps,watch,computed} from 'vue';
import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import {getServerUrl} from "@/config/sys";
import axios from "@/util/axios";
import { ElMessage } from "element-plus";

const formRef=ref(null)
const quillKey = ref(0);
const bigTypeId=ref("")
const smallTypeId=ref("")
const bigTypeSlectOptions =ref([])
const smallTypeSlectOptions =ref([])

const props=defineProps({
  dialogTitle:{
    type:String,
    default:'',
    required:true
  },
  dialogValue:{
    type:Object,
    default:()=>{}
  },
  dialogVisible: { 
    type: Boolean,
    default: false
  },
})



const form=ref({
  id: -1,
  proName:'',
  proPrice:0.0,
  proStock:0,
  proSort:0,
  bigTypeId:-1,
  smallTypeId:-1,
  introImgs: "",
  description: "",
  load: false
})

const resetFormValue = () => {
  form.value = {
    id: -1,
    proName:'',
    proPrice:0.0,
    proStock:0,
    proSort:0,
    bigTypeId:-1,
    smallTypeId:-1,
    introImgs: "",
    description: ""
  };
};



const emits=defineEmits(['update:modelValue','initProductList'])

const hasValidId = computed(() => {
  return form.value?.id !== null && form.value?.id !== -1;
});

// 关闭表单
const handleClose = () => {
  formRef.value.resetFields();
  bigTypeId.value = null,
  smallTypeId.value = null,
  quillKey.value++;  // 强制重新渲染 QuillEditor
  console.log("dddddddddddddddddddddd")
  resetFormValue();
  emits('update:modelValue',false)
}



const rules=ref({
  proName:[
    {
      required: true,
      message: '请输入产品小类名称！',
    }
  ],
  proPrice:[
    { required: true, message: '请输入产品价格!' },
    { type: 'number', message: '产品价格是数值类型！',transform: (value) => Number(value) },
  ],
  proStock:[
    { required: true, message: '请输入产品库存!' },
    { type: 'number', message: '产品库存是数值类型！',transform: (value) => Number(value) },
  ],
  description:[
    {
      required: true,
      message: '请输入产品小类描述！',
    },
  ],
  introImgs:[
    {
      required: true,
      message: '请输入产品介绍！',
    }
  ]
})

const handleEditorReady = (quill) => {
  // 获取图片工具栏按钮
  const toolbar = quill.getModule('toolbar')
  
  // 自定义图片上传处理
  toolbar.addHandler('image', () => {
    const input = document.createElement('input')
    input.setAttribute('type', 'file')
    input.setAttribute('accept', 'image/*')
    input.click()
    
    input.onchange = async () => {
      const file = input.files[0]
      if (file) {
        const formData = new FormData()
        formData.append('file', file)
        
        try {

          // 修改此处：在路径后加上 form.value.id
          let uploadUrl = '/uploadImage/introImage/'
          if (form.value.id && form.value.id !== -1) {
            uploadUrl += form.value.id
          }

          // 调用后端图片上传接口
          const response = await axios.post(uploadUrl, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          // 假设返回的图片路径在 response.data.url
          const imageUrl = getServerUrl() + response.data.data.src
          
          // 获取当前光标位置
          const range = quill.getSelection()
          if (range) {
            // 插入图片路径而不是base64
            quill.insertEmbed(range.index, 'image', imageUrl)
          }
        } catch (error) {
          ElMessage.error('图片上传失败')
          console.error('Upload error:', error)
        }
      }
    }
  })
}


const initBigTypeSelectList=async()=>{
  console.log('xxx')
  const res=await axios.post("admin/bigType/listAll");
  bigTypeSlectOptions.value=res.data.bigTypeList;
}

const initSmallTypeSelectList=async(bigTypeId)=>{
  console.log('bigTypeId='+bigTypeId)
  if (bigTypeId === null){
    return;
  }
  const res=await axios.post("admin/smallType/listAll/"+bigTypeId);
  smallTypeSlectOptions.value=res.data.smallTypeList;
}


initBigTypeSelectList();

//不直接绑定在fromg上，因为quillConent会改变，所以要单独绑定
const quillIntroImgs = ref('');
const handleConfirm = () => {
  // 同步 quillIntroImgs到from中
  form.value.introImgs = quillIntroImgs.value;
  form.value.bigTypeId= bigTypeId.value;
  form.value.smallTypeId= smallTypeId.value;
  if(form.value.bigTypeId==""){
    ElMessage.error("请选择产品类别");
    return;
  }
  formRef.value.validate(async (valid) => {
    if (valid) {
      console.log("xxx")
       try{
        let result=await axios.post("admin/product/save",form.value);
        let data=result.data;
        if(data.code==0){
          ElMessage.success("执行成功");
          formRef.value.resetFields();
          bigTypeId.value=""
          emits("initProductList")
          handleClose();
        }else{
          ElMessage.error(data.msg);
        }
      }catch(err){
        console.log("error:"+err)
        ElMessage.error('系统运行出错，请联系管理员');
      }
    } else {
      return false
    }
  })
}

const handleBigTypeChange = (val) => {
  console.log("val="+val)
  smallTypeId.value=null;
  if (val != undefined || val != -1)
  initSmallTypeSelectList(val);
}

//已弃用
const getBigTypeIdBySmallTypeId=async (smallTypeId)=>{
  if(smallTypeId===-1 || smallTypeId===undefined){
    return null;
  }
  const res=await axios.get("admin/smallType/getBigTypeIdBySmallTypeId/"+smallTypeId);
  console.log(res.data.bigTypeId)
  handleBigTypeChange(res.data.bigTypeId)
}

watch(
  ()=>props.dialogValue,
  ()=>{
    quillKey.value++;
    console.log(props.dialogValue.introImgs);
    if(props.dialogValue.id===-1 || props.dialogValue.id === undefined){
      console.log("是添加")
      // 重置表单
      resetFormValue();
      quillIntroImgs.value = null;
    }else{
      console.log("是修改")
      if (props.dialogValue.load===true){
        props.dialogValue.load=false;
        form.value=props.dialogValue;
        // 初始化大类和小类
        bigTypeId.value=form.value.bigTypeId;
        smallTypeId.value=form.value.smallTypeId;
        quillIntroImgs.value = props.dialogValue.introImgs || '';
        // 初始化小类列表
        initSmallTypeSelectList(form.value.bigTypeId);
        // getBigTypeIdBySmallTypeId(props.dialogValue.smallTypeIdTypeId);
      }
    }
  },
  {deep:true,immediate:true}
)

</script>

<style scoped>

.sort-tip{
  margin-left: 10px;
  color: #909399;
  font-size: 12px;
}

</style>